import Vue from 'vue';

import WorkerInductionConstants from '@/core/worker-induction/worker-induction.constants';

export default {
  namespaced: true,

  state: {
    answers: {},
    oneTimePass: null,
    workerAssessment: null,
    workerOneTimePass: null,
  },

  mutations: {
    setAnswer(state, { answer, fieldUuid }) {
      Vue.set(state.answers, fieldUuid, answer);
    },
    setOneTimePass(state, oneTimePass) {
      state.oneTimePass = oneTimePass;
    },
    setWorkerAssessment(state, workerAssessment) {
      state.workerAssessment = workerAssessment;
      state.answers = _.get(workerAssessment, 'attributes.metadata', {});
    },
    setWorkerOneTimePass(state, workerOneTimePass) {
      state.workerOneTimePass = workerOneTimePass;
    },
  },

  getters: {
    assessmentSections: state => _.get(state, 'workerAssessment.relationships.assessment.data.relationships.sections', []),
    filteredAssessmentSections: (state, getters) => getters.assessmentSections.filter((section) => {
      const workerOTPSections = _.get(state, 'workerOneTimePass.assessment_sections', []);
      return workerOTPSections.some(workerOTPSection => _.get(workerOTPSection, 'attributes.uuid') === _.get(section, 'uuid'));
    }),
    flattenedAssessmentFields: (state, getters) => _.flatten(getters.filteredAssessmentSections.map(section => section.flattened())),
    filteredAssessmentFields: (state, getters) => getters.flattenedAssessmentFields.filter((field) => {
      const { parentUuid } = field;
      if (!parentUuid) {
        return true;
      }

      const parentAnswers = _.flatten([state.answers[parentUuid]]);
      return parentAnswers.includes(field.allowedParentResponse);
    }),
    getAnswer: state => fieldUuid => state.answers[fieldUuid],
    isWorkerOneTimePassInProgress: (state, getters) => getters.filteredAssessmentFields.some(field => !!getters.getAnswer(field.uuid)) ||
      getters.workerInductions.length !== getters.unfinishedWorkerInductions.length,
    oneTimePassClientName: state => _.get(state.oneTimePass, 'client.trading_names[0].name', ''),
    unansweredAssessmentFields: (state, getters) => getters.filteredAssessmentFields.filter(field => !getters.getAnswer(field.uuid)),
    unfinishedWorkerInductions: (state, getters) => getters.workerInductions
      .filter(induction => _.get(induction, 'current_status') !== _.get(WorkerInductionConstants, 'current_status.completed.key')),
    workerInductions: state => _.get(state.workerOneTimePass, 'worker_inductions', []),
    workerOneTimePassStatus: state => _.get(state.workerOneTimePass, 'current_status'),
  },
};
